import type { AppFeatures } from '../../../../layers/core/app/types/configurationFlags';
import type { PersonalFeatures } from '../../../../layers/personal/app/types/configurationFlags';

/** Override Veloair's default configuration flags */
export const CONFIGURATION_FLAGS: Partial<AppFeatures & PersonalFeatures> = {
  planFinder: false,
  planComparison: false,
  outstandingBalance: false,
  receipts: true,
  seatsLeft: false,
  aggregatedAvailabilities: {
    searchAnywhere: true,
    customGroups: true,
    dateCarouselPreFill: true,
    optionalSearchDates: true,
  },
  multiBeneficiary: false,
  detailedPriceBreakdown: true,
};
